module.exports = __webpack_public_path__ + "static/media/bolt-purple.06d86805.svg";